import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { EditorSignUpField, EditorSignUpFieldListItem, EditorSignUpFieldType } from '@dev/template-editor';
import { getMergeFieldsStore } from '@/store/mergeFields/actions';
import { mapMergeFieldToEditorSignUpField } from '@/services/tools/mapMergeFieldToEditorSignUpField';
import { useContactLists } from '../useContactLists';

interface FormMergeFields {
    fields: EditorSignUpField[];
    isLoading?: boolean;
}

const contactListsItemsFormatOutput = (items: EditorSignUpFieldListItem[]) => items.map((item) => `<input type="hidden" name="listNames" value="${item.label}" />`).join('');
interface FormMergeFieldsProps {
    isGalleryCreator: boolean,
    includePaymentFields?: boolean,
}

export const useFormMergeFields = ({ isGalleryCreator, includePaymentFields }: FormMergeFieldsProps): FormMergeFields => {
    const { data, maxFieldsValuesMap } = useSelector(getMergeFieldsStore);
    const { t } = useTranslation();
    const lists = useContactLists();
    const fields = useMemo(() => data?.MergeFields?.filter(({ CollectName }) => CollectName), [data])?.map(
        (field): EditorSignUpField => mapMergeFieldToEditorSignUpField(field, maxFieldsValuesMap),
        [data]
    );

    const predefinedDemoFields: EditorSignUpField[] = [
    {
        "id": "optinlists",
        "name": "field_optinlists",
        "type": EditorSignUpFieldType.CHECKBOX,
        "isDefault": true,
        "isRequired": false,
        isRemovingBlocked: false,
        isRequiredHidden: !isGalleryCreator,
        "title": t('emailoptinfield_title'),
        "label": t('emailoptinfield_label'),
        "placeholder": "",
        "description": t('emailoptinfield_customerdescription'),
        "inputAttributes": { value: "true" },
        "listLabel": t('emailoptinfield_subscriberlists'),
        "listItems": lists,
        "listItemsFormatOutput": contactListsItemsFormatOutput,
    },
    {
        "id": "terms",
        "name": "field_terms",
        "type": EditorSignUpFieldType.CHECKBOX,
        "isDefault": true,
        "isRequired": true,
        isRemovingBlocked: false,
        "title": t('termsandconditions'),
        "label": t('termsandconditions_label'),
        "labelLinkText": t('termsandconditions'),
        "labelLinkTextTitle": t('termsandconditions_labellinktitle'),
        "labelLinkUrl": "./checkout#terms",
        "placeholder": "",
        "inputAttributes": { value: "true" }
    }
    ];

    return { fields: [...fields ?? [], ...(includePaymentFields ? predefinedDemoFields : [])] };
};
